import React, { useRef, useState } from 'react'
import injectStyles from 'react-jss'

import { SelectDashboard, Dropzone } from '../../../../../Components/Form'
import {
  StyledCancelButton,
  StyledConfirmButton,
} from '../../../../../Components/Campaigns/Page/Conversions/CountdownTimer/styles'
import { styles } from './styles'

const AddStateForm = ({
  classes,
  handleClose,
  handleSave,
  statesForUS,
  isLoading,
}) => {
  const [selectedState, setSelectedState] = useState(null)
  const [file, setFile] = useState(null)
  const dropzoneRef = useRef(null)

  const stateOptions = statesForUS.map(item => ({
    label: item.name,
    value: item.code,
  }))

  const handleRemoveFile = () => {
    if (dropzoneRef.current) {
      dropzoneRef.current.props.onDrop([])
      setFile(null)
    }
  }

  const onSubmit = async () => {
    await handleSave({ state: selectedState, file })
  }

  return (
    <div className={classes.wrapper}>
      <SelectDashboard
        onChange={(event, index, value) => {
          setSelectedState(value)
        }}
        label="State"
        value={selectedState}
        options={stateOptions}
      />
      <Dropzone
        innerRef={dropzoneRef}
        className={classes.dropzone}
        input={{
          onChange: file => setFile(file[0]),
        }}
        accept={'application/pdf'}
        mainLabel="Drop your file here"
      />
      {file ? (
        <StyledCancelButton onClick={handleRemoveFile}>
          Delete
        </StyledCancelButton>
      ) : (
        <div />
      )}

      <div className={classes.buttonWrapper}>
        <StyledCancelButton onClick={handleClose}>Cancel</StyledCancelButton>
        <StyledConfirmButton
          onClick={onSubmit}
          isReached
          disabled={!selectedState || !file || isLoading}
        >
          {isLoading
            ? 'Loading...'
            : !selectedState
            ? 'Select state'
            : !file
            ? 'Upload file'
            : 'Save'}
        </StyledConfirmButton>
      </div>
    </div>
  )
}

export default injectStyles(styles)(AddStateForm)
